import uuidHelper, { findWithUUID } from '@/utils/uuidHelper';
import { assignIfExistsToMany } from '@/utils/resultsHelper';
import { linkPrefixes } from '@/constants/urls';
import { isPmnTransferEnabled } from '@/auth/featureToggles';
import { cascadeFieldTypeUpdate } from './helper';

const newDictionaryField = () => {
  const field = {
    constraints: null,
    description: null,
    entity: false,
    cohort_filter: false,
    label: null,
    name: null,
    type: 'text',
    uri: { link: null, protocol: linkPrefixes.HTTPS },
    uuid: uuidHelper.generate(),
  };
  if (isPmnTransferEnabled()) {
    field.pseudonymisation_rule = null;
  }
  return field;
};

export const addNewField = (datasetFields, uuid, properties) => {
  Object.keys(properties).forEach((key) => (
    datasetFields.push({
      key: properties[key],
      uuid,
    })
  ));
};

export const assignLookupToField = (lookups, constraints = null, dataType = 'text', pmnFunctions = []) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const datasetFields = dictionary.fields.filter((item) => item.constraints === lookups.activeLookupName);
  assignIfExistsToMany(datasetFields, { constraints, type: dataType });
  datasetFields.forEach((field) => cascadeFieldTypeUpdate(field, pmnFunctions));

  return dictionary;
};

export const activeField = (lookups) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  return findWithUUID(dictionary.fields, lookups.activeFieldUUID);
};

export default newDictionaryField;
